<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title class="ion-text-center header-title">{{ 'CONTACT.TITLE' | translate }}</ion-title>

      <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
        <ion-button [routerLink]="['/']" replaceUrl class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button>
      </ion-buttons>

       <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>

<ion-content>

  <ion-grid fixed class="ion-padding">
    <ion-row>
      <ion-col class="info">

        <h1 class="info__title">{{ 'CONTACT.COMPANY' | translate }}</h1>

        <p class="info__content">{{ 'CONTACT.TABLE42_FULL_NAME' | translate }}<br/>
          Vurnikov trg 3<br/>
          4240 Radovljica<br/>
          Slovenija
        </p>

         <p class="info__content">{{ 'CONTACT.COMPANY_TAX_NUMBER' | translate }}: 19579390<br/>
          {{ 'CONTACT.COMPANY_ID' | translate }}: 9116079000<br/>
          {{ 'CONTACT.COMPANY_BANK_ACCOUNT' | translate }}: SI56 1010 0005 9932 706 {{ 'CONTACT.BY_BANK' | translate }} Banki  Intesa Sanpaolo d.d.
        </p>

        <h1 class="info__title">{{ 'CONTACT.HELP_AND_SUPPORT' | translate }}</h1>
        <p class="info__content">
          {{ 'CONTACT.EMAIL' | translate }}: <a href="mailto:podpora@table42.app">podpora@table42.app</a>
        </p>
        <p class="info__content">
          {{ 'CONTACT.PHONE' | translate }}: <a href="tel:+38631312039"><span *ngIf="translateService.currentLang == 'sl'">0</span><span *ngIf="translateService.currentLang !== 'sl'">+386 </span>31 312 039</a>
        </p>

        <h1 class="info__title">{{ 'CONTACT.MANAGEMENT_AND_SALES' | translate }}</h1>
        
        <p class="info__content">{{ 'CONTACT.EMAIL' | translate }}: <a href="mailto:stik@table42.app">stik@table42.app</a></p>
        <p class="info__content">{{ 'CONTACT.PHONE' | translate }}: <a href="tel:+38631312038"><span *ngIf="translateService.currentLang == 'sl'">0</span><span *ngIf="translateService.currentLang !== 'sl'">+386 </span>31 312 038</a></p>

        <h1 class="info__title">{{ 'CONTACT.WEBSITE' | translate }}</h1>
        <p class="info__content"><a href="https://table42.app">https://table42.app</a></p>

        

      </ion-col>

    </ion-row>
  </ion-grid>
 
</ion-content>